import i18n from '@/i18n';

const configModalActionBlock = {
    id: '',
    title: '',
    model: false,
    scrollable: true,
    hideFooter: false,
    size: 'lg',
    class: 'h-30',
    validate: true
};

const configFileds = {
    configFontSizeTitleBlock: {
        isRequired: false,
        isNumber: true,
        error: false,
        maxlength: 10,
        errorField: i18n.t('landingPage.settingDesgin.fontSizeTitleBlock')
    }
};

export { configModalActionBlock, configFileds };
